module.exports = __webpack_public_path__ + "media/registration/conferences@3x-0f7ffabc.png";